<template>
  <router-view class="wizard" />
</template>

<style scoped lang="scss">
  .wizard {
    ::v-deep .layout {
      padding-top: 60px;

      @include min-sm {
        padding-top: 180px;
      }
    }

   ::v-deep .heading {
      max-width: 350px;

      @include min-sm {
        max-width: 520px;
        margin-bottom: 100px;
      }
    }

    ::v-deep .button-group {
      margin-bottom: 30px;
    }
  }
</style>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'Wizard',

    computed: {
      ...mapState([
        'filters'
      ])
    },

    watch: {
      'filters': {
        handler: function (val, oldVal) {
          this.$store.commit('updateProperties', []);
        },
        deep: true
      }
    }
  };
</script>